(() => {
  const fontLink = document.getElementById('BrushZooIconFont');
  if (fontLink) {
    const names = new Set(fontLink.dataset.iconNames.split(','));
    let timer;
    const collect = (root) => {
      if (root.nodeType === Node.TEXT_NODE) root = root.parentElement;
      if (!(root instanceof Element)) return;
      const icons = [...root.querySelectorAll('.material-symbols-outlined')];
      if (root.matches('.material-symbols-outlined')) icons.push(root);
      let changed = false;
      for (const icon of icons) {
        const name = icon.textContent.trim();
        if (/^[a-z][a-z0-9_]{0,79}$/.test(name) && !names.has(name)) {
          names.add(name);
          changed = true;
        }
      }
      if (changed) {
        clearTimeout(timer);
        timer = setTimeout(() => {
          const url = new URL(fontLink.href);
          url.searchParams.set('icon_names', [...names].sort().join(','));
          fontLink.href = url.href;
        }, 50);
      }
    };
    collect(document.body);
    new MutationObserver((records) => {
      for (const record of records) {
        if (record.type === 'characterData') collect(record.target);
        else {
          if (record.target instanceof Element && record.target.matches('.material-symbols-outlined')) collect(record.target);
          for (const node of record.addedNodes) collect(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('.localization-v2__button');
    if (!button) return;
    const form = button.closest('localization-form');
    if (!form) return;
    for (const image of form.querySelectorAll('img[data-brushzoo-src]')) {
      image.src = image.dataset.brushzooSrc;
      delete image.dataset.brushzooSrc;
    }
  }, true);
})();

(() => {
  const observed = new WeakSet();
  const initialize = (root) => {
    for (const video of root.querySelectorAll('video[data-brushzoo-viewport]')) {
      if (observed.has(video)) continue;
      observed.add(video);
      let visible = false;
      let resume = false;
      video.addEventListener('play', () => {
        if (!visible) {
          resume = true;
          video.pause();
        }
      });
      new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        if (visible && resume) {
          resume = false;
          video.play().catch(() => {});
        } else if (!visible && !video.paused) {
          resume = true;
          video.pause();
        }
      }, { threshold: 0.01 }).observe(video);
    }
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
